export const state = {
  enabled: false,
  selectedFiltersDate: false,
  selectedFiltersDevice: false,
  selectedFiltersCycle: false,
  selectedFiltersActivity: false,
  selectedFiltersDeviceState: false,
  selectedFiltersDeviceStateHistory: false,
  selectedFiltersEdge: false,
  selectedFiltersInsights: false,
  selectedFiltersInsightsDesigner: false,
  selectedSetting: false,
  selectedDetails: false,
  selectedCompact: false,
}

export const getters = {
  enabled(state) {
    return state.enabled
  },
  selectedFiltersDate(state) {
    return state.selectedFiltersDate
  },
  selectedFiltersDevice(state) {
    return state.selectedFiltersDevice
  },
  selectedFiltersCycle(state) {
    return state.selectedFiltersCycle
  },
  selectedFiltersActivity(state) {
    return state.selectedFiltersActivity
  },
  selectedFiltersDeviceState(state) {
    return state.selectedFiltersDeviceState
  },
  selectedFiltersDeviceStateHistory(state) {
    return state.selectedFiltersDeviceStateHistory
  },
  selectedFiltersEdge(state) {
    return state.selectedFiltersEdge
  },
  selectedFiltersInsights(state) {
    return state.selectedFiltersInsights
  },
  selectedFiltersInsightsDesigner(state) {
    return state.selectedFiltersInsightsDesigner
  },
  selectedSetting(state) {
    return state.selectedSetting
  },
  selectedDetails(state) {
    return state.selectedDetails
  },
  selectedCompact(state) {
    return state.selectedCompact
  },
}

export const mutations = {
  SET_ENABLED(state, enabled) {
    state.enabled = enabled
  },
  SET_FILTERS_DATE(state, filters) {
    state.selectedFiltersDate = filters
  },

  SET_FILTERS_DEVICE(state, filters) {
    state.selectedFiltersDevice = filters
  },
  SET_FILTERS_CYCLE(state, filters) {
    state.selectedFiltersCycle = filters
  },
  SET_FILTERS_ACTIVITY(state, filters) {
    state.selectedFiltersActivity = filters
  },
  SET_FILTERS_EDGE(state, filters) {
    state.selectedFiltersEdge = filters
  },
  SET_FILTERS_INSIGHTS(state, filters) {
    state.selectedFiltersInsights = filters
  },

  SET_FILTERS_INSIGHTS_DESIGNER(state, filters) {
    state.selectedFiltersInsightsDesigner = filters
  },
  SET_FILTERS_DEVICE_STATE(state, filters) {
    state.selectedFiltersDeviceState = filters
  },
  SET_FILTERS_DEVICE_STATE_HISTORY(state, filters) {
    state.selectedFiltersDeviceStateHistory = filters
  },
  SET_DETAILS(state, details) {
    state.selectedDetails = details
  },
  SET_COMPACT(state, details) {
    state.selectedCompact = details
  },
}

export const actions = {
  setCompact({ commit, state, rootState }, { compact }) {
    commit('SET_COMPACT', compact)
  },

  setInfo(
    { commit, state, rootState },
    {
      enabled,
      filtersDate,
      filtersDevice,
      filtersCycle,
      filtersActivity,
      filtersDeviceState,
      filtersDeviceStateHistory,
      filtersEdge,
      filtersInsights,
      filtersInsightsDesigner,
      details,
    }
  ) {
    if (enabled !== null && enabled !== undefined) {
      commit('SET_ENABLED', enabled)
    }
    if (filtersDate !== null && filtersDate !== undefined) {
      commit('SET_FILTERS_DATE', filtersDate)
    }
    if (filtersDevice !== null && filtersDevice !== undefined) {
      commit('SET_FILTERS_DEVICE', filtersDevice)
    }
    if (filtersCycle !== null && filtersCycle !== undefined) {
      commit('SET_FILTERS_CYCLE', filtersCycle)
    }
    if (filtersActivity !== null && filtersActivity !== undefined) {
      commit('SET_FILTERS_ACTIVITY', filtersActivity)
    }
    if (filtersDeviceState !== null && filtersDeviceState !== undefined) {
      commit('SET_FILTERS_DEVICE_STATE', filtersDeviceState)
    }
    if (filtersDeviceStateHistory !== null && filtersDeviceStateHistory !== undefined) {
      commit('SET_FILTERS_DEVICE_STATE_HISTORY', filtersDeviceStateHistory)
    }
    if (filtersEdge !== null && filtersEdge !== undefined) {
      commit('SET_FILTERS_EDGE', filtersEdge)
    }
    if (filtersInsights !== null && filtersInsights !== undefined) {
      commit('SET_FILTERS_INSIGHTS', filtersInsights)
    }
    if (filtersInsightsDesigner !== null && filtersInsightsDesigner !== undefined) {
      commit('SET_FILTERS_INSIGHTS_DESIGNER', filtersInsightsDesigner)
    }
    if (details !== null && details !== undefined) {
      commit('SET_DETAILS', details)
    }
  },
}
